import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';


@Injectable()
export class IPolicyGuard implements CanActivate {

    constructor(private store: Store, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const list = this.store.selectSnapshot(state => state.ioffer.policies);
        if (!list || list.length === 0) {
            return this.router.parseUrl('/ioffer/no-state');
        }
        return true;
    }
}
